import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Партнёры по обмену: встречная выгода и город. Главный экран сервиса.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function MatchingScreen(): ReactNode {
  return (
    <section>
      <h1>Подбор обменов</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
